import { QueryClient } from "@tanstack/react-query";

const ONE_HOUR = 1000 * 60 * 60;

// Create a client with 1-hour cache for curriculum data
export default new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: ONE_HOUR,
            gcTime: ONE_HOUR * 2,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
        },
    },
})